import axios from "axios";
import { normalizePhoneNumber } from "../../utils/phone";
import { BASE_URL } from "../config/config";
import { AmbassadorApplicationPayload } from "./ambassadorship.types";

export const submitAmbassadorApplication = async (
  payload: AmbassadorApplicationPayload
): Promise<void> => {
  try {
    await axios.post(`${BASE_URL}/v2/others/ambassadorship/applications`, {
      fullName: payload.fullName.trim(),
      email: payload.email.trim(),
      phoneNumber: normalizePhoneNumber(payload.phoneNumber),
      universityName: payload.universityName.trim(),
      faculty: payload.faculty.trim(),
      department: payload.department.trim(),
      level: payload.level,
      ...(payload.linkedinUrl?.trim() && { linkedinUrl: payload.linkedinUrl.trim() }),
    });
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || "Failed to submit ambassador application"
    );
  }
};
